import { TextField } from "@mui/material";
import { SubtypeState } from "../../../../types/actionModule/editor/subtypeEditorTypes";
import { TextAnswerSubtypeResponse } from "../../../../types/actionModule/subtypes/textAnswerSubtype";

export default function TextAnswerEditorPreview(state: SubtypeState) {

    const subtype = state.properties as Partial<TextAnswerSubtypeResponse>;
    const hintText = subtype.hintText;

    return <TextField
        id="outlined-basic"
        label={hintText}
        variant="outlined"
        size="small"
        fullWidth />;
}